/*
In React Bootstrap, which adapts Bootstrap's CSS framework for use in React applications, the grid system is based on a series of containers, rows, and columns that use a series of containers to layout and align content. It's built with flexbox and allows up to 12 columns across the page. The col-xx-xx classes are part of this grid system and help define the width of a column at different breakpoints.

Here's a breakdown of the available classes and what they represent in terms of device or viewport sizes:

1. .col-
Usage: .col- or .col
Effect: Allows the column to automatically size itself based on the number of columns in the row.
2. .col-sm-
Breakpoint: ≥ 576px (Small devices - landscape phones)
Usage: .col-sm-1 to .col-sm-12
Effect: Specifies the number of columns the element should span on small devices.
3. .col-md-
Breakpoint: ≥ 768px (Medium devices - tablets)
Usage: .col-md-1 to .col-md-12
Effect: Specifies the number of columns the element should span on medium devices.
4. .col-lg-
Breakpoint: ≥ 992px (Large devices - desktops)
Usage: .col-lg-1 to .col-lg-12
Effect: Specifies the number of columns the element should span on large devices.
5. .col-xl-
Breakpoint: ≥ 1200px (Extra large devices - large desktops)
Usage: .col-xl-1 to .col-xl-12
Effect: Specifies the number of columns the element should span on extra large devices.
6. .col-xxl-
Breakpoint: ≥ 1400px (XX-Large devices - larger desktops)
Usage: .col-xxl-1 to .col-xxl-12
Effect: Specifies the number of columns the element should span on XX-large devices.
How to Use
The number after the breakpoint prefix indicates how many of the 12 available columns are occupied by the container at that particular breakpoint. For example, if you use .col-md-8, it means that on medium devices and wider (at least 768px wide), the column will take up 8 of the 12 columns (or two-thirds) of the row's width.
*/
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { catalogueSagaActions } from "..";

import { Button, Card, Carousel, Row } from "react-bootstrap";
import { ArrowLeftCircleFill, ArrowRightCircleFill } from "react-bootstrap-icons";


import catalogStyles from "../css/Catalogue.module.css";
import carouselStyles from "../css/Carousel.module.css";
import "../css/Generic.css";
import { truncateText } from "../../../../utilities/lookup";

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

export const ServiceItemsCatalogueCarousel = ({ serviceItems, serviceId, serviceItemsTotalCount, deptId }) => {

  const history = useHistory();

  const dispatch = useDispatch();

  const uniqueId = "carousel-" + Math.random().toString(36).substr(2, 9);

  //const [columnCardsCount, setColumnCardsCount] = useState(10);
  //const [cardHeight, setCardHeight] = useState('300px'); // Default height


  const columnCardsCount = 10; //set this to the number cards to be displayed in earch carousel item

  // const getColumnSizeClass = (columnCount) => {
  //   const sizes = {
  //     10: 'col-lg-1 col-md-2 col-sm-3',  // Adjust these as necessary for 10 columns
  //     9: 'col-lg-1 col-md-2 col-sm-3',   // Adjust these as necessary for 9 columns
  //     8: 'col-lg-2 col-md-3 col-sm-4',   // Adjust these as necessary for 8 columns
  //     7: 'col-lg-2 col-md-3 col-sm-4',   // Adjust these as necessary for 7 columns
  //     6: 'col-lg-2 col-md-4 col-sm-6',   // Suitable for 6 columns
  //     4: 'col-lg-3 col-md-4 col-sm-6',   // Suitable for 4 columns
  //     3: 'col-lg-4 col-md-6 col-sm-6',   // Suitable for 3 columns
  //     2: 'col-lg-6 col-md-6 col-sm-12'   // Suitable for 2 columns
  //   };
  //   return sizes[columnCount] || 'col-12'; // Default to full width if no match
  // };

  // Debounce function
  // function debounce(func, wait) {
  //   let timeout;
  //   return function(...args) {
  //     const context = this;
  //     clearTimeout(timeout);
  //     timeout = setTimeout(() => func.apply(context, args), wait);
  //   };
  // }


  // useEffect(() => {
  //   const updateColumnCount = debounce(() => {
  //     const width = window.innerWidth;
  //     if (width >= 1600) {
  //       setColumnCardsCount(10); // Very large screens - 1400 -> xxl
  //     } else if (width >= 1400) {
  //       setColumnCardsCount(9); // Larger screens - 1200 -> xl
  //     } else if (width >= 1200) {
  //       setColumnCardsCount(8); // Large desktops - 992 -> lg
  //     } else if (width >= 992) {
  //       setColumnCardsCount(7); // Small desktops - 768 -> md
  //     } else if (width >= 768) {
  //       setColumnCardsCount(6); // Tablets landscape - 576 -> sm
  //     } else if (width >= 576) {
  //       setColumnCardsCount(4); // Tablets portrait - xs
  //     } else if (width >= 400) {
  //       setColumnCardsCount(3); // Large phones
  //     } else {
  //       setColumnCardsCount(2); // Small phones
  //     }
  //   }, 250); // Debounce period in milliseconds

  //   window.addEventListener('resize', updateColumnCount);
  //   updateColumnCount(); // Initial update on mount

  //   return () => {
  //     window.removeEventListener('resize', updateColumnCount);
  //   };
  // }, []);


  let dummyArray = Array(Math.ceil(serviceItemsTotalCount / columnCardsCount)).fill(0);

  const handlePayClick = (selectedItem) => {

    history.push({ pathname: "/payment-management/payment-form", state: { selectedItem, deptId } });
    dispatch(catalogueSagaActions.setSerivceItem(selectedItem));
  };


  // useEffect(() => {

  //   console.log("****************************");
  //   console.log("columnCardsCount: ", columnCardsCount);
  //   console.log("dummyArray: ", dummyArray.length);
  //   console.log("serviceItemsTotalCount: ", serviceItemsTotalCount);
  //   console.log("window.innerWidth: ", window.innerWidth);

  //   console.log("****************************");

  //   },[columnCardsCount]);

  return (
    <>
      <style>
        {`
          .${uniqueId} .carousel-control-prev,
          .${uniqueId} .carousel-control-next {
            width: 40px !important;
            height: 40px !important;
            top: 50% !important;
            transform: translateY(-50%) !important;
            bottom: auto !important;
            background: none !important;
            border: none !important;
            opacity: 0.7;
            z-index: 10;
          }
 
        `}
      </style>
      <div className={uniqueId}>

        <Carousel
          prevIcon={<ArrowLeftCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} />}
          nextIcon={<ArrowRightCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} />}
          controls={serviceItemsTotalCount > columnCardsCount ? true : false}
          indicators={true}
          interval={null} /* set to null to stop carousel from cycling */
        >
          {dummyArray.map((val, y) =>
            <Carousel.Item key={"yyy_" + y}>
              <Row>
                {serviceItems.slice(((y) * columnCardsCount), ((y + 1) * columnCardsCount)).map((item, z) =>
                  <div className='col-xxl-4 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex' key={"zzz_" + z}>
                    <Card className={`${carouselStyles.carouselCardNoImage} w-100 mb-10`}>
                      <Card.Body className={`${carouselStyles.cardBody}`}>
                        <Card.Title className={carouselStyles.carouselCardTitle}>
                          <span title={item.description}>{truncateText(item.description, 25)}</span>
                          <hr />
                        </Card.Title>
                        <Card.Text>
                          <span style={{ fontSize: "14px" }}> <b>{moneyFormater.format(item.price)}</b> </span>
                          <br />
                          <span style={{ fontSize: "14px" }}>Revenue Code: {item.service_item_number}</span>
                        </Card.Text>
                        <Button className={`${carouselStyles.cardBodyButton}`} variant="primary" onClick={() => handlePayClick(item)}>Pay</Button>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </Row>
            </Carousel.Item>
          )}
        </Carousel>
      </div>
    </>
  );
};
